module.exports = __webpack_public_path__ + "img/coding.7ab56a95.jpg";